// Shared category catalogue for Royal Lady — keeps navigation, filters, admin
// forms and product labels in perfect sync. Adding a new category anywhere in
// the app is a one-line change here.
//
// Order matters — it is preserved in the mobile drawer, home tiles, footer, etc.
export const CATEGORIES = [
  { key: "t-shirts", label: "T-Shirts", sizes: ["XS", "S", "M", "L", "XL", "XXL"], image: "https://images.unsplash.com/photo-1574889455435-7dc7e14ccf60?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "shirts", label: "Shirts", sizes: ["XS", "S", "M", "L", "XL", "XXL"], image: "https://images.unsplash.com/photo-1656308859253-634095bc987b?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "jeans", label: "Jeans", sizes: ["24", "26", "28", "30", "32", "34", "36"], image: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "sarees", label: "Sarees", sizes: ["Free Size"], image: "https://images.unsplash.com/photo-1616091216791-a5360b5fc78a?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "dress-materials", label: "Dress Materials", sizes: ["Unstitched"], image: "https://images.unsplash.com/photo-1610030181087-540017dc9d61?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "kurtis", label: "Kurtis", sizes: ["XS", "S", "M", "L", "XL", "XXL"], image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "night-wear", label: "Night Wear", sizes: ["S", "M", "L", "XL"], image: "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "salwar-suits", label: "Salwar Suits", sizes: ["S", "M", "L", "XL", "XXL"], image: "https://images.unsplash.com/photo-1583391733956-6c78276477e2?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "college-collection", label: "College Collection", sizes: ["XS", "S", "M", "L", "XL"], image: "https://images.unsplash.com/photo-1516762689617-e1cffcef479d?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "office-wear", label: "Office Wear", sizes: ["XS", "S", "M", "L", "XL", "XXL"], image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "palazzo", label: "Palazzo Collection", sizes: ["S", "M", "L", "XL", "XXL"], image: "https://images.unsplash.com/photo-1585487000160-6ebcfceb0d03?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "innerwear", label: "Innerwear", sizes: ["XS", "S", "M", "L", "XL"], image: "https://images.unsplash.com/photo-1571908599407-cdb918ed83bf?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "footwear", label: "Slippers & Sandals", sizes: ["4", "5", "6", "7", "8", "9"], image: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "jewellery", label: "Fashion Jewellery", sizes: ["Free Size"], image: "https://images.unsplash.com/photo-1611652022419-a9419f74343d?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
  { key: "beauty", label: "Beauty Collection", sizes: ["Standard"], image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?crop=entropy&cs=srgb&fm=jpg&q=90&w=800" },
];

export const CATEGORY_KEYS = CATEGORIES.map((c) => c.key);

const LABEL_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.key, c.label]));

// Full label — used in headers, breadcrumbs, admin dropdown.
export const categoryLabel = (key) => LABEL_MAP[key] || "Shop";

// Compact label for tiny product-card eyebrows (singular where sensible).
const SHORT_LABEL_MAP = {
  "t-shirts": "T-Shirt",
  shirts: "Shirt",
  jeans: "Jeans",
  sarees: "Saree",
  "dress-materials": "Dress Material",
  kurtis: "Kurti",
  "night-wear": "Night Wear",
  "salwar-suits": "Salwar Suit",
  "college-collection": "College",
  "office-wear": "Office Wear",
  palazzo: "Palazzo",
  innerwear: "Innerwear",
  footwear: "Footwear",
  jewellery: "Jewellery",
  beauty: "Beauty",
};
export const categoryShortLabel = (key) => SHORT_LABEL_MAP[key] || LABEL_MAP[key] || "Item";

export const sizePresetsFor = (key) => {
  const c = CATEGORIES.find((x) => x.key === key);
  return c ? c.sizes : ["S", "M", "L", "XL"];
};
